// Labels visíveis pra cada valor armazenado no banco (snake_case sem acento → label PT-BR).

export const CULTURA_OPTIONS = [
  { value: 'soja',  label: 'Soja' },
  { value: 'milho', label: 'Milho' },
] as const;

export const FONTE_OPTIONS = [
  { value: 'rta',                   label: 'RTA' },
  { value: 'nota_fiscal',           label: 'Nota Fiscal' },
  { value: 'romaneio',              label: 'Romaneio' },
  { value: 'controle_interno',      label: 'Controle Interno' },
  { value: 'laudo_at',              label: 'Laudo/Assistência Técnica' },
  { value: 'declaracao_produtor',   label: 'Declaração do Produtor' },
] as const;

export const TECNOLOGIA_OPTIONS = [
  { value: 'alta',  label: 'Alta' },
  { value: 'ponta', label: 'Ponta' },
  { value: 'media', label: 'Média' },
  { value: 'baixa', label: 'Baixa' },
] as const;

export const CULTIVO_OPTIONS = [
  { value: 'plantio_direto', label: 'Plantio Direto' },
  { value: 'convencional',   label: 'Convencional' },
] as const;

export const MAO_DE_OBRA_OPTIONS = [
  { value: 'contratada', label: 'Contratada' },
  { value: 'familiar',   label: 'Familiar' },
] as const;

export const FERTILIDADE_OPTIONS = [
  { value: 'alta',  label: 'Alta' },
  { value: 'media', label: 'Média' },
  { value: 'baixa', label: 'Baixa' },
] as const;

export const AGRICULTURA_OPTIONS = [
  { value: 'transgenica',  label: 'Transgênica' },
  { value: 'tradicional',  label: 'Tradicional' },
] as const;

export const IRRIGACAO_OPTIONS = [
  { value: 'sem_irrigacao', label: 'Sem Irrigação' },
  { value: 'pivo_central',  label: 'Pivô Central' },
  { value: 'gotejamento',   label: 'Gotejamento' },
] as const;

export const STATUS_OPTIONS = [
  { value: 'pendente',   label: 'Pendente' },
  { value: 'confirmado', label: 'Confirmado' },
  { value: 'ajustar',    label: 'Ajustar' },
] as const;

export const TIPO_POSSE_OPTIONS = [
  { value: 'proprio',       label: 'Próprio' },
  { value: 'arrendamento',  label: 'Arrendamento' },
] as const;

// Conveniência: map value → label pra uso em renders read-only.
function toMap<T extends ReadonlyArray<{ value: string; label: string }>>(opts: T): Record<string, string> {
  return Object.fromEntries(opts.map((o) => [o.value, o.label]));
}

export const CULTURA_LABELS     = toMap(CULTURA_OPTIONS);
export const FONTE_LABELS       = toMap(FONTE_OPTIONS);
export const TECNOLOGIA_LABELS  = toMap(TECNOLOGIA_OPTIONS);
export const CULTIVO_LABELS     = toMap(CULTIVO_OPTIONS);
export const MAO_DE_OBRA_LABELS = toMap(MAO_DE_OBRA_OPTIONS);
export const FERTILIDADE_LABELS = toMap(FERTILIDADE_OPTIONS);
export const AGRICULTURA_LABELS = toMap(AGRICULTURA_OPTIONS);
export const IRRIGACAO_LABELS   = toMap(IRRIGACAO_OPTIONS);
export const STATUS_LABELS      = toMap(STATUS_OPTIONS);
export const TIPO_POSSE_LABELS  = toMap(TIPO_POSSE_OPTIONS);

export function statusTone(s: string): 'ok' | 'warn' | 'danger' | 'neutral' {
  if (s === 'confirmado') return 'ok';
  if (s === 'ajustar') return 'danger';
  if (s === 'pendente') return 'warn';
  return 'neutral';
}

// Conversão sacas <-> kg (peso padrão 60 kg/sc pra soja/milho).
export const KG_POR_SACA = 60;
export const scToKg = (sc: number): number => sc * KG_POR_SACA;
export const kgToSc = (kg: number): number => kg / KG_POR_SACA;
